import React, {useEffect, useState} from "react";
import TalentSideMenu from "../../components/TalentSideMenu";
import {useNavigate, useParams} from "react-router-dom";
import TalentHeader from "components/TalentHeader";
import {useDispatch, useSelector} from "react-redux";
import {ThunkDispatch} from "@reduxjs/toolkit";
import {
  getNewsDetail, getNewsRecommend, updateNumberOfViews,
  setCanBackPrevPage, setNewsBookmark, setError, setSuccess,
  setNewsCardBookmark,
} from "reducers/talentHome";
import {formatDate, formatTimeAgo, toFullWidthNumber, parseTags} from "utils/format";
import {
  setChatSelected,
  setIsChatting,
  setIsScout,
  setMessages,
  setIsNewChatFormOtherScreen,
  setIsLoadNewListChat,
} from "reducers/chatMessage";
import ReturnButton from "../../components/ReturnButton";
import CustomIconButton from "../../components/CustomIconButton";
import NotFoundPage from "../../pages/NotFoundPage";
import Copyright from "../../components/Copyright";
import CustomToast from "../../components/CustomToast";
import { useSnackbar } from "notistack";
import NewsCard from "./components/NewsCard";
import MarkdownViewer from "../../components/MarkdownViewer";

const NewsItem = (item:any) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();
  item = item?.item ? item?.item : item;

  const goDetail = (id: any) => {
    dispatch(setCanBackPrevPage(true));
    navigate("/talent/news/" + id)
  }

  const handleBookmark = (id) => {
    dispatch(setNewsCardBookmark({id: id, view: "news", requestBody: {}}));
  }

  return (
      <div className="rounded-2xl overflow-hidden bg-white group alu-section-box-shadow">
        <NewsCard items={item} goToDetail={(id) => goDetail(id)} handleBookmark={(id) => handleBookmark(id)} line_option="line-clamp-1" />
      </div>
  )
}

const TalentNews = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const currentUser = useSelector((state: any) => state.currentUser)
  const { 
    newsDetail, newsRecommend, actionName, 
    actionStatus, canBackPrevPage, success,
    error, isReloadNews,
  } = useSelector((state: any) => state.talentHome);
  const {chatList} = useSelector((state: any) => state.chatMessage);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (id) {
      const data = {
          id: Number(id),
      }
      dispatch(getNewsDetail(data));
      dispatch(getNewsRecommend(data));
      dispatch(updateNumberOfViews(data));
      scrollToTop();
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      const data = {
        id: Number(id),
      }
      dispatch(getNewsRecommend(data));
    }
  }, [isReloadNews]);

  const showToast = (title: string, message: string, variant: string, textLink: string = "", clickOnText: any = "") => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (
        <CustomToast title={title} message={message} variant={variant} textLink={textLink} clickOnText={clickOnText} snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };

  useEffect(() => {
    if(actionName == "setNewsBookmark" || actionName == "setNewsCardBookmark"){
      if(success){
        showToast('メッセージ', success, "success");
        dispatch(setSuccess(null));
      }
      else if(error){
        showToast('メッセージ', error, "error");
        dispatch(setError(null));
      }
    }
  }, [error, success]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  
  if (!newsDetail || (Array.isArray(newsDetail) && newsDetail.length === 0) || Object.keys(newsDetail).length === 0) {
    if(actionName == "getNewsDetail" && actionStatus == "rejected") return <NotFoundPage />;
    return null;
  }

  const goToChat = () => {
      dispatch(setIsChatting(true));
      dispatch(setIsNewChatFormOtherScreen(true));
      dispatch(setIsScout(false));
      dispatch(setChatSelected({}));
      dispatch(setMessages([]));
      if(chatList.length > 0) {
        dispatch(setIsLoadNewListChat(false));
      }
      navigate('/talent/message')
  }

  const goBack = () => {
    if(canBackPrevPage) {
      navigate(-1)
    } else {
      navigate("/talent")
    }
  }

  const handleBookmark = (id) => {
    dispatch(setNewsBookmark({id: id, view: "news", requestBody: {}}));
  }

  return (
    <>
      <TalentHeader prevPage={{ name: "ホーム", onClick: () => goBack() }} />
      <div className="pb-[56px] md:pb-0 md:mt-4 md:px-2 lg:mt-6 lg:px-6 flex lg:gap-6 md:gap-3 relative">
        <TalentSideMenu />
        <div className="flex-1">
          <div className="mb-6 md:flex items-center gap-4 hidden">
            <ReturnButton onClick={() => goBack()} />
            <span className="text-sm alu-text-base-1">/</span>
            <h3 className="text-xl leading-[1.875rem] alu-text-base-2 font-bold">
              ニュース
            </h3>
          </div>
          <div className="mt-4 md:mt-0 md:flex md:gap-3 lg:gap-6">
            <div className="mb-8 mx-2 md:mx-0 md:mb-4 md:rounded-2xl pb-0 bg-white md:flex-1 md:h-max md:p-6 alu-section-box-shadow">
              <h3 className="mb-2 md:mb-4 text-2xl leading-[2.25rem] alu-text-base-2 font-bold hidden md:block break-words break-all">
                {newsDetail?.title}
              </h3>
              <div className="mb-2 md:mb-6 md:flex items-center justify-between text-sm alu-text-base-1 hidden">
                <p className="flex gap-2">
                  {newsDetail?.news_type_display?.name}
                  {newsDetail?.tags && <p className="text-sm leading-[1.3125rem] alu-text-base-1">
                      {parseTags(String(newsDetail?.tags)).map((tag: string, index: number) => (
                          <span key={index} className="mr-1">#{tag.trim()}{index < parseTags(String(newsDetail?.tags)).length - 1 && ','}</span>
                      ))}
                  </p>}  
                </p>
                <p>{formatDate(newsDetail?.public_date)}</p>
              </div>
              {newsDetail?.images && (
                <div className="aspect-video md:mb-4">
                <img
                    className="object-contain w-full h-full md:rounded-[0.25rem]"
                    src={newsDetail.images}
                    alt="news"
                />
                </div>
              )}
              <div className="p-4 pb-12 md:p-0">
                <h3 className="mb-2 text-2xl leading-[2.25rem] alu-text-base-2 font-bold md:hidden break-words break-all">
                  {newsDetail?.title}
                </h3>
                <div className="flex items-center justify-between text-sm alu-text-base-1 md:hidden">
                  <p>{newsDetail?.news_type_display?.name}</p>
                  <p>{formatDate(newsDetail?.public_date)}</p>
                </div>
                {newsDetail?.tags && <p className="text-sm leading-[1.3125rem] alu-text-base-1 md:hidden mt-1">
                    {parseTags(String(newsDetail?.tags)).map((tag: string, index: number) => (
                        <span key={index} className="mr-1">#{tag.trim()}{index < parseTags(String(newsDetail?.tags)).length - 1 && ','}</span>
                    ))}
                </p>}
                <p className="text-base alu-text-base-2 whitespace-pre-wrap break-words break-all mt-2">
                  <MarkdownViewer content={newsDetail.contents} />
                </p>
              </div>
            </div>

            {/* related list in mobile screen */}
            <div className="md:hidden px-4">
              <h5 className="mb-2 text-xl alu-text-base-2 font-bold md:text-base">
                関連記事
              </h5>
              <div className="flex flex-col gap-4 mb-4">
                {newsRecommend.map((item: any, idx: any) => (
                  <NewsItem key={idx} item={item} />
                ))}
              </div>
              <Copyright view="talent" />
            </div>

            <div className="hidden md:block md:w-[200px] lg:shrink-0 lg:w-[260px] xl:w-[320px]">
              <button onClick={goToChat} className="hidden md:block mb-4 w-full md:px-3 md:py-2 lg:px-6 lg:py-3 border border-[#FF861A] bg-alu-primary text-white hover:bg-[#ea6d00] md:text-sm lg:text-base text-center rounded-[0.25rem] disabled:border-none disabled:bg-[#BBB] disabled:text-white font-bold">
                相談する
              </button>
              <div onClick={() => handleBookmark(newsDetail.id)} className="hidden mb-4 py-1 px-2 md:flex items-center gap-1 hover:bg-[#FFF3E5] cursor-pointer w-fit rounded">
                <button>
                  {!newsDetail.is_bookmarked ?
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <g clipPath="url(#clip0_11236_7241)">
                      <path d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z" fill="#FF861A"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_11236_7241">
                          <rect width="24" height="24" fill="white"/>
                      </clipPath>
                      </defs>
                  </svg> :
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <g clipPath="url(#clip0_11236_7249)">
                      <path d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3Z" fill="#FF861A"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_11236_7249">
                          <rect width="24" height="24" fill="white"/>
                      </clipPath>
                      </defs>
                  </svg>}
                </button>
                <p
                className={`text-sm text-[#FF861A]`}
                >
                {!newsDetail.is_bookmarked ? 'この記事をブックマーク' : 'ブックマーク済み'}
                </p>
              </div>
              <h5 className="mb-2 text-xl alu-text-base-2 font-bold md:text-base">
                関連記事
              </h5>
              <div className="flex flex-col gap-4 mb-4">
                {newsRecommend.map((item: any, idx: any) => (
                  <NewsItem key={idx} item={item} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden md:block">
        <Copyright view="talent" />
      </div>
    </>
  );
};

export default TalentNews;
